import React, { useEffect, useState } from "react";
import {
  GallerySectionContainer,
  HighlightContainer,
  HighlightInnerContainer,
  HomeContainer,
  NewsSectionContainer,
  SectionContainer,
  FloatingIconWrapper,
  ContainerWidth,
  HighlightContainerOuter,
  OuterNewsContainer,
  SliderContainer,
  InnerContainer,
  TimelineLabel,
} from "./HomeDetails.styled";
import Card from "../../../components/atoms/NewCard";
import HomeHighlightCard from "./HighlightCard";
import HomeNewsCard from "./NewsCard";
import BigHomeNewsCard from "./BigNewsCard";
import HomeGalleryCard from "./GalleryCard";
import SliderWrapper from "../../../components/atoms/SliderWrapper";
import Activity from "./Activity";

import BannerCity from "../../../components/molecules/v2/BannerCity";
import Section from "../../../components/atoms/Section";
import {
  usePageContextFunction,
  usePageContextState,
} from "../../../context/PageContext";
import {
  useFetchEventDetail,
  useFetchGalleryArticle,
  useFetchHighlightArticle,
  useFetchWhatNew,
  useFetchSection,
  useFetchTimelineSeries,
  useFetchVideos,
  useFetchActivity,

  // useFetchActivityArticle,
} from "../../../networks";
import { useNavigate, useParams } from "react-router-dom";
import { func } from "../../../utils";
import { NewFooter, Spacer } from "../../../components";
import analytics from "../../../utils/analytics";
import { capitalizeFLetter } from "../../../utils/function";
import moment from "moment";
import Announce from "../../../components/atoms/Announce";
import Sponsor from "../../../components/atoms/Sponsor";
import MediaPartner from "../../../components/atoms/MediaPartner";
import Broadcaster from "../../../components/atoms/Broadcaster";
import useWindowSize from "../../../hooks/useWindowSize";
import Lottie from "react-lottie";
import * as animationData from "../../../assets/animation/floatingIcon.json";
import HallOfFameCard from "./HallOfFameCard";
import { Container } from "../Home/Home.styled";
import CityTimeline from "../../../components/atoms/CityTimeline.tsx";
import Video from "./Video";

// Mark a section active only when it crosses the viewport's vertical center
// (same technique as HomePressCon). With the default full-viewport band several
// sections report "in view" at once and the last one wins, so idInView is
// unreliable — the navbar could think a below-the-fold section is active at the
// top. A center line keeps exactly one section active end to end.
const ACTIVE_LINE = "-50% 0px -50% 0px";

const HomeDetail = ({ slug }) => {
  const {
    setOpenPopUp: toglePopUp,
    setPageMode,
    setCity,
    setIsLive,
    setVideoUrl,
    setIsRegist,
    setRegistrationUrl,
  } = usePageContextFunction();

  const { idInView } = usePageContextState();

  const { size } = useWindowSize();

  useEffect(() => {
    setPageMode("home-details");
  }, []);
  const { city } = useParams();
  const slugCity = slug?.city || city;
  const { data: dataHighlightArticle, isFetching: fetchingHighlightArticle } =
    useFetchHighlightArticle(slugCity);
  const { data: dataGalleryArticle } = useFetchGalleryArticle(slugCity);
  const { data: dataWhatsNewArticle } = useFetchWhatNew(slugCity);
  const { data: dataTimelineRaw } = useFetchTimelineSeries(slugCity);
  // const { data: dataActivityArticle } = useFetchActivityArticle(slugCity);

  const dataTimeline = dataTimelineRaw?.data?.data?.timeline ?? [];

  const dataHighlight = dataHighlightArticle?.data?.data ?? [];
  const dataGalleryRaw = dataGalleryArticle?.data?.data ?? [];

  const { data: dataVideosRaw } = useFetchVideos(city, !!city);
  const dataVideo = dataVideosRaw?.data?.data || [];

  const dataWhatsNew = dataWhatsNewArticle?.data?.data ?? [];
  const cityCaptialize = capitalizeFLetter(slugCity);

  // Use dummy data instead of API data
  // const dataActivity = dataActivityArticle?.data?.data ?? dummyActivityData;

  const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

  const isLoading = fetchingHighlightArticle;

  const isMobileView = (size?.width || 0) <= 830;

  const { data: dataEventDetail } = useFetchEventDetail(slugCity);
  const dataEvent = dataEventDetail?.data?.data?.eventDetail ?? {};

  const { data: dataActivityRaw, isLoading: isLoadingActivity } =
    useFetchActivity(slugCity);
  const dataActivityList = dataActivityRaw?.data?.data ?? [];
  const dataActivity = dataActivityList?.map((item) => {
    return {
      id: item?.id,
      slug: item?.slug,
      title: item?.title,
      key_visual: item?.key_visual,
      key_visual_mobile: item?.key_visual_mobile,
    };
  });

  const navigate = useNavigate();

  const [isShowFloating, setIsShowFloating] = useState(true);
  const [navbarShow, setNavbarShow] = useState(false);

  const { data: dataSectionRaw } = useFetchSection();

  const dataSection = dataSectionRaw?.data?.data?.sections ?? [];

  const {
    event_start_date,
    event_end_date,
    video_url,
    maxstream_link,
    registration_url,
  } = dataEvent;

  const startDate = moment(event_start_date);
  const endDate = moment(event_end_date);

  // Dummy data for Activity section since API isn't ready yet
  const dummyActivityData = [
    {
      id: 1,
      title: "Best Supporter",
      image_url: func.getStaticImg("/bg/activity-img-1.jpg"),
      key_visual: "activity-img-1.jpg",
      key_visual_mobile: "activity-img-1-mobile.jpg",
      description: `Calon peserta Piala by.U ${cityCaptialize} 2025 harap mengisi form registrasi awal berikut. Periode registrasi Piala by.U ${cityCaptialize} dibuka dari tanggal ${startDate?.format(
        "DD MMMM YYYY",
      )} hingga ${endDate?.format(
        "DD MMMM YYYY",
      )} . Semua data isian menjadi hak panitia penyelenggara sebagai acuan untuk memilih peserta. Pengumuman peserta piala by.U ${cityCaptialize} yakni tanggal (menyesuaikan kota tersebut).!`,
    },
    {
      id: 2,
      title: "uStore\nCollection",
      image_url: func.getStaticImg("/bg/activity-img-2.jpg"),
      key_visual: "activity-img-2.jpg",
      key_visual_mobile: "activity-img-2-mobile.jpg",
      description: "Exclusive merchandise hanya di uStore ",
    },
    {
      id: 3,
      title: "Best Supporter",
      image_url: func.getStaticImg("/bg/activity-img-3.jpg"),
      key_visual: "activity-img-3.jpg",
      key_visual_mobile: "activity-img-3-mobile.jpg",
      description: "Supporter Terbaik",
    },
    {
      id: 4,
      title: "uStore\nCollection",
      image_url: func.getStaticImg("/bg/activity-img-4.jpg"),
      key_visual: "activity-img-4.jpg",
      key_visual_mobile: "activity-img-4-mobile.jpg",
      description: "Exclusive merchandise hanya di uStore ",
    },
  ];
  // const dataActivity = dummyActivityData;
  const isShowFloat = React.useMemo(() => {
    return isShowFloating && !idInView?.includes("footer") && !navbarShow;
  }, [navbarShow, isShowFloating]);

  const liveStreaming = React.useMemo(() => {
    const currentDate = moment();
    // Live when either channel has a link; BannerCity picks which one to open.
    if (
      !!(video_url || maxstream_link) &&
      currentDate.isSameOrAfter(startDate, "day") &&
      currentDate.isSameOrBefore(endDate, "day")
    ) {
      setIsLive(true);
      setVideoUrl(video_url);
      return {
        isLive: true,
      };
    }

    setIsLive(false);
    setVideoUrl("");
    return { isLive: false };
  }, [video_url, maxstream_link]);

  // const registration = React.useMemo(() => {
  //   const currentDate = moment();
  //   if (!!registration_url && currentDate.isBefore(startDate, "day")) {
  //     setIsRegist(true);
  //     setRegistrationUrl(registration_url);
  //     return {
  //       isRegist: true,
  //     };
  //   }

  //   setIsRegist(false);
  //   setRegistrationUrl("");
  //   return { isRegist: false };
  // }, [registration_url]);

  const handleShowFloatingIcon = () => {
    setIsShowFloating(true);
  };
  const handleHideFloatingIcon = () => {
    setIsShowFloating(false);
  };

  useEffect(() => {
    analytics.sendEvent({
      event: "pialabyu_cityLP",
      city: capitalizeFLetter(slugCity),
    });

    setCity(slugCity);
    setVideoUrl(video_url);
  }, [slugCity, liveStreaming?.isLive]);

  useEffect(() => {
    let timeout;

    const handleScroll = () => {
      setIsShowFloating(false);

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setIsShowFloating(true);
      }, 200); // Adjust the timeout value as needed
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeout);
    };
  }, []);

  const handleClickNavbar = (e) => {
    const className = String(e.target.className);

    if (className?.includes("navbar")) {
      setNavbarShow(className?.includes("onOpen"));
      handleHideFloatingIcon();
    }
  };

  const _renderNewsMobileView = (data) => {
    return data?.map((value, idx) => (
      <HomeNewsCard
        key={idx}
        title={value?.title}
        subTitle={value?.subtitle}
        imgSrc={
          isMobileView
            ? imgPath + value?.key_visual_mobile
            : imgPath + value?.key_visual
        }
        mobileView={isMobileView}
        onClick={() => {
          toglePopUp({
            state: true,
            data: value,
            currentCity: slugCity,
          });
        }}
      />
    ));
  };

  const _renderNewsDesktopView = (data) => {
    return data?.map((value, idx) => (
      <>
        <HomeNewsCard
          key={idx}
          title={value?.title}
          subTitle={value?.subtitle}
          imgSrc={
            isMobileView
              ? imgPath + value?.key_visual_mobile
              : imgPath + value?.key_visual
          }
          mobileView={isMobileView}
          onClick={() => {
            toglePopUp({
              state: true,
              data: value,
              currentCity: slugCity,
            });
          }}
        />
      </>
    ));
  };

  /* Listen to navbar clicked */
  useEffect(() => {
    window.addEventListener("click", handleClickNavbar);

    return () => {
      window.removeEventListener("click", handleClickNavbar);
    };
  }, []);

  return (
    <div
      // Jangan contain: kalau halamannya lebih pendek dari rasio gambar
      // (1440x2983), contain ngecilin lebarnya (mis. jadi 975px) lalu gambarnya
      // di-repeat ke samping, muncul garis vertikal di tengah banner.
      className={!isMobileView ? "!bg-cover !bg-no-repeat" : ""}
      style={{
        overflowX: "hidden",
        background: `url(${func.getStaticImg(`${"/bg/bg-home-detail.jpg"}`)})`,
        backgroundPositionY: "auto",
      }}
    >
      <Section
        //className={"w-100vw"}
        id="home-detail-banner"
        rootMargin={ACTIVE_LINE}
        height={"auto"}
        backgroundColor={"inherit"}
        background={`url(${func.getStaticImg(
          `${
            isMobileView ? "/bg/bg-home-detail-m.jpg" : "/bg/bg-home-detail.jpg"
          }`,
        )}), no-repeat center auto / cover`}
      >
        {isShowFloat && (
          <FloatingIconWrapper
            key={isShowFloat}
            onClick={() => {
              func.scrollTo("footer-landing", null, 64);
            }}
          >
            <Lottie
              style={{ width: 120, height: 120 }}
              options={{
                animationData: animationData,
              }}
            />
          </FloatingIconWrapper>
        )}
        {/* <FloatingIcon
            key={isShowFloat}
            style={isShowFloat ? styles.onShow : styles.onHide}
            src={func.getStaticImg("/illustration/Floating.png")}
            onClick={() => {
              func.scrollTo("footer-landing");
            }}
          /> */}

        <BannerCity
          data={dataEvent}
          slug={slugCity}
          isLive={liveStreaming?.isLive}
        ></BannerCity>
      </Section>

      <HomeContainer>
        {dataTimeline?.length > 0 ? (
          <Section
            id="timeline"
            rootMargin={ACTIVE_LINE}
            height={"auto"}
            backgroundColor={"inherit"}
            background={
              "linear-gradient(180deg, rgba(31, 45, 61, 0.00) 0%, #1F2D3D 54.06%)"
            }
          >
            <ContainerWidth>
              <SectionContainer
                paddingRight="0px"
                paddingLeft="0px"
                backgroundColor={"inherit"}
                marginBottom={"0px"}
              >
                {isMobileView ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <h5
                      style={{
                        textAlign: "left",
                        marginTop: 24,
                        marginLeft: 16,
                        color: "white",
                        fontWeight: "bold",
                        fontSize: 20,
                      }}
                    >
                      Timeline
                    </h5>
                  </div>
                ) : (
                  <TimelineLabel>Timeline</TimelineLabel>
                )}
                <CityTimeline
                  data={dataTimeline}
                  mode={isMobileView ? "mobile" : "desktop"}
                />
              </SectionContainer>
            </ContainerWidth>
          </Section>
        ) : (
          <></>
        )}

        {dataActivity?.length > 0 && (
          <Activity
            data={dataActivity}
            isMobileView={isMobileView}
            imgPath={imgPath}
            backgroundImage={func.getStaticImg("/bg/bg-highlight-smoke.png")}
            onClickCard={(item) => {
              navigate(
                `/${city}/reader-detail/${item?.slug}/${encodeURIComponent(
                  item?.title,
                )}/Activity`,
              );
              // toglePopUp({
              //   state: true,
              //   data: item,
              //   currentCity: slugCity,
              //   typePopUp: "activity",
              // });
            }}
          />
        )}

        {dataVideo?.length > 0 && <Video data={dataVideo} />}

        {dataHighlight?.length !== 0 && !isLoading && (
          <Section
            id="home-detail-content"
            rootMargin={ACTIVE_LINE}
            height={"auto"}
            backgroundColor={"#1F2D3D"}
          >
            <HighlightContainer
              backgroundImage={func.getStaticImg("/bg/bg-highlight-smoke.png")}
            >
              {/* <SwooshSVG
                src={func.getStaticImg(
                  isMobileView
                    ? `/bg/sharp-swoosh.svg`
                    : `/bg/sharp-swoosh-d.svg`
                )}
              /> */}
              <HighlightContainerOuter>
                {isMobileView ? (
                  <h5
                    style={{
                      width: "100%",
                      textAlign: "left",
                      fontWeight: "bold",
                      color: "white",
                      fontSize: 20,
                      marginBottom: 8,
                    }}
                  >
                    Highlight
                  </h5>
                ) : (
                  <h1
                    style={{
                      width: "100%",
                      textAlign: "left",
                      fontSize: 40,
                      fontWeight: "bold",
                      color: "white",
                      marginBottom: 36,
                    }}
                  >
                    Highlight
                  </h1>
                )}

                {isMobileView || dataHighlight?.length <= 3 ? (
                  <HighlightInnerContainer>
                    {dataHighlight?.map((value, idx) => (
                      <HomeHighlightCard
                        key={idx}
                        title={value?.title}
                        subTitle={value?.subtitle}
                        imgSrc={
                          isMobileView
                            ? imgPath + value?.key_visual_mobile
                            : imgPath + value?.key_visual
                        }
                        onClick={() => {
                          navigate(
                            `/${city}/reader-detail/${
                              value?.slug
                            }/${encodeURIComponent(value?.title)}/Highlight`,
                          );
                          // toglePopUp({
                          //   state: true,
                          //   data: value,
                          //   currentCity: slugCity,
                          // });
                        }}
                      />
                    ))}
                  </HighlightInnerContainer>
                ) : (
                  <InnerContainer>
                    <SliderContainer>
                      {
                        <SliderWrapper
                          showDotsIndicator={false}
                          showItems={3}
                          step={1}
                          fixStep
                          style={{
                            width: "100%",
                          }}
                          cardWrapperStyle={{ width: "100%" }}
                          totalData={dataHighlight?.length ?? 0}
                        >
                          {({ _, cardWidth }) => {
                            return (
                              <>
                                {dataHighlight?.map((value, idx) => (
                                  <HomeHighlightCard
                                    key={idx}
                                    title={value?.title}
                                    subTitle={value?.subtitle}
                                    cardWidth={cardWidth - 3}
                                    imgSrc={
                                      isMobileView
                                        ? imgPath + value?.key_visual_mobile
                                        : imgPath + value?.key_visual
                                    }
                                    onClick={() => {
                                      navigate(
                                        `/${city}/reader-detail/${
                                          value?.slug
                                        }/${encodeURIComponent(
                                          value?.title,
                                        )}/Highlight`,
                                      );
                                      // toglePopUp({
                                      //   state: true,
                                      //   data: value,
                                      //   currentCity: slugCity,
                                      // });
                                    }}
                                  />
                                ))}
                              </>
                            );
                          }}
                        </SliderWrapper>
                      }
                    </SliderContainer>
                  </InnerContainer>
                )}
              </HighlightContainerOuter>
            </HighlightContainer>
          </Section>
        )}

        {dataWhatsNew?.length !== 0 && (
          <Section
            id="home-detail-content-01"
            rootMargin={ACTIVE_LINE}
            height={"auto"}
            backgroundColor={"#1F2D3D"}
            padding={isMobileView ? "inherit" : "10vh 0"}
          >
            <ContainerWidth>
              <SectionContainer paddingRight="0px">
                {isMobileView ? (
                  <h5
                    style={{
                      width: "100%",
                      textAlign: "left",
                      fontWeight: "bold",
                      color: "white",
                      fontSize: 20,
                      margin: "16px 0 0 0",
                    }}
                  >
                    Berita Terbaru
                  </h5>
                ) : (
                  <h3
                    style={{
                      width: "100%",
                      textAlign: "left",
                      margin: "10px 0 0 0",
                      color: "white",
                      fontSize: 40,
                      fontWeight: "bold",
                    }}
                  >
                    Berita Terbaru
                  </h3>
                )}
                <OuterNewsContainer>
                  <NewsSectionContainer>
                    {isMobileView
                      ? _renderNewsMobileView(dataWhatsNew)
                      : _renderNewsDesktopView(dataWhatsNew)}
                  </NewsSectionContainer>
                </OuterNewsContainer>
              </SectionContainer>
            </ContainerWidth>
          </Section>
        )}

        <Container
          id="hall-of-fame"
          backgroundColor="transparent"
          paddingTop={"0"}
        >
          <Section
            id="hall-of-fame"
            rootMargin={ACTIVE_LINE}
            height={"auto"}
            backgroundColor={"inherit"}
            background={
              isMobileView
                ? "linear-gradient(180deg, #1F2D3D 0%, rgba(31, 45, 61, 0) 30%, rgba(31, 45, 61, 0) 85%, #1F2D3D 100%)"
                : "linear-gradient(180deg, #1F2D3D 0%, rgba(31, 45, 61, 0) 70%, rgba(31, 45, 61, 0) 88%, #1F2D3D 100%)"
            }
          >
            <HallOfFameCard slug={slugCity} />
          </Section>
        </Container>

        {dataGalleryRaw?.length > 0 && (
          <Section
            id="home-detail-content-02"
            rootMargin={ACTIVE_LINE}
            height={"auto"}
            backgroundColor={"#1F2D3D"}
            padding={isMobileView ? "inherit" : "10vh 0"}
            className={isMobileView ? "!bg-cover" : "!bg-cover !flex !flex-col"}
            background={`url(${func.getStaticImg(
              "/bg/bg-highlight-smoke.png",
            )}) transparent center`}
          >
            <>
              <ContainerWidth backgroundColor={"transparent"}>
                <SectionContainer>
                  {isMobileView ? (
                    <h5
                      style={{
                        width: "100%",
                        textAlign: "left", // Already left-aligned
                        margin: "48px 0 16px 16px", // Add left margin for better alignment in mobile
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "20px", // Add explicit font size for consistency
                      }}
                    >
                      Gallery
                    </h5>
                  ) : (
                    <h1
                      style={{
                        width: "100%",
                        textAlign: "left",
                        margin: "0",
                        color: "white",
                        fontSize: 40,
                        fontWeight: "bold",
                      }}
                    >
                      Gallery
                    </h1>
                  )}
                  <GallerySectionContainer
                    className={isMobileView ? "px-4" : ""}
                  >
                    {dataGalleryRaw?.map((value, idx) => {
                      return (
                        <HomeGalleryCard
                          key={idx}
                          title={value?.title}
                          imgSrc={imgPath + value?.key_visual}
                          onClick={() => window.open(value?.drive_url)}
                        />
                      );
                    })}
                  </GallerySectionContainer>
                </SectionContainer>
              </ContainerWidth>
              <Spacer marginBottom={isMobileView ? "16px" : "32px"} />
            </>
          </Section>
        )}
        <Section
          id="home-detail-content-02"
          rootMargin={ACTIVE_LINE}
          height={"auto"}
          backgroundColor={"#1F2D3D"}
          padding={isMobileView ? "inherit" : "10vh 0 0 0"}
          className={"!bg-cover !flex !flex-col"}
        >
          {dataSection?.length !== 0 && (
            <>
              {dataSection
                ?.filter((val) => val?.id === 1)
                .map((value, idx) => {
                  if (!value?.section_contents?.length) return null;
                  return (
                    <Section
                      id="sponsor"
                      padding={"16px 0px 0px 0px"}
                      className={"!relative"}
                      //backgroundColor={isMobileView ? "#F0F2F9" : "white"}
                      height={"auto"}
                      display={isMobileView ? "inherit" : "flex"}
                    >
                      <Sponsor
                        key={idx}
                        title={value?.section_name}
                        contents={value?.section_contents}
                        titleClassName="text-white"
                      ></Sponsor>
                    </Section>
                  );
                })}
            </>
          )}

          {dataSection?.length !== 0 && (
            <>
              {dataSection
                ?.filter((val) => val?.id === 3)
                ?.map((value, idx) => {
                  if (!value?.section_contents?.length) return null;
                  return (
                    <Section
                      key={idx}
                      id="sponsor"
                      padding={
                        isMobileView ? "10vh 0px 0px 0px" : "0px 0px 0px 0px"
                      }
                      //backgroundColor={isMobileView ? "#F0F2F9" : "white"}
                      height={isMobileView ? "auto" : "auto"}
                      display={isMobileView ? "inherit" : "flex"}
                      className={!isMobileView ? "w-1/2" : ""} // Make each section take half the width
                    >
                      {value?.id === 3 && (
                        <Broadcaster
                          key={idx}
                          title={value?.section_name}
                          contents={value?.section_contents}
                          titleClassName="text-white"
                          isInline={!isMobileView} // Pass prop to indicate inline display
                        ></Broadcaster>
                      )}
                      {/* {value?.id === 2 ? (
                        <MediaPartner
                          key={idx}
                          title={value?.section_name}
                          contents={value?.section_contents}
                          titleClassName="text-white"
                          isInline={!isMobileView} // Pass prop to indicate inline display
                        ></MediaPartner>
                      ) : (
                        <Broadcaster
                          key={idx}
                          title={value?.section_name}
                          contents={value?.section_contents}
                          titleClassName="text-white"
                          isInline={!isMobileView} // Pass prop to indicate inline display
                        ></Broadcaster>
                      )} */}
                    </Section>
                  );
                })}
            </>
          )}
        </Section>
      </HomeContainer>

      <Section
        id={"footer-landing-home-detail"}
        rootMargin={ACTIVE_LINE}
        height={"auto"}
        scrollSnap={"start"}
        backgroundColor={"#1F2D3D"}
        background={"#1F2D3D"}
      >
        <NewFooter />
      </Section>
    </div>
  );
};

const styles = {
  onHide: {
    opacity: 0,
  },
  onShow: {
    opacity: 1,
    transition: "opacity 0.2s linear",
  },
};

export default HomeDetail;
